import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RequestQueueService } from "./request-queue.service";

@Injectable({
  providedIn: "root"
})
export class HttpService {
  constructor(
    private readonly http: HttpClient,
    private readonly queue: RequestQueueService
  ) {}

  get<T = unknown>(url: string, headers?: HttpHeaders) {
    return this.queue.process(
      this.http.get<T>(url, {
        headers
      })
    );
  }

  getBlob(url: string, headers?: HttpHeaders) {
    return this.queue.process(
      this.http.get(url, {
        headers,
        responseType: "blob"
      })
    );
  }

  post<T = unknown>(url: string, body?: unknown, headers?: HttpHeaders) {
    return this.queue.process(
      this.http.post<T>(url, body, {
        headers
      })
    );
  }

  postBlob(url: string, body?: unknown, headers?: HttpHeaders) {
    return this.queue.process(
      this.http.post(url, body, {
        headers,
        responseType: "blob"
      })
    );
  }

  patch<T = unknown>(url: string, body?: unknown) {
    return this.queue.process(this.http.patch<T>(url, body));
  }

  del<T = unknown>(url: string, headers?: HttpHeaders) {
    return this.queue.process(
      this.http.delete<T>(url, {
        headers
      })
    );
  }
}
